import { useState, useContext } from "react";
import { SessionContext } from "../SessionContext";
import classNames from "classnames";
import Section from "../parts/Section";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [loginError, setLoginError] = useState(false);

  const sessionContext = useContext(SessionContext);
  const navigate = useNavigate();

  if (sessionContext.user) {
    navigate("/");
  }

  const login = async (event: React.FormEvent) => {
    event.preventDefault();

    setLoginError(false);
    setIsLoading(true);
    const success = await sessionContext.login(username, password);
    setIsLoading(false);

    if (!success) {
      setLoginError(true);
      return;
    }

    navigate("/");
  };

  return (
    <Section className="p-4">
      <form className="m-auto my-4 flex flex-col gap-4" onSubmit={login}>
        <input
          className={classNames("border rounded py-2 px-4", {
            "border-red-700": loginError,
          })}
          placeholder="Usuário"
          type="text"
          onChange={(e) => setUsername(e.target.value)}
          autoFocus
        />

        <input
          className={classNames("border rounded py-2 px-4", {
            "border-red-700": loginError,
          })}
          placeholder="Senha"
          type="password"
          onChange={(e) => setPassword(e.target.value)}
        />

        <button
          className="rounded py-2 px-4 bg-sky-600 hover:bg-sky-500 font-extrabold text-white disabled:opacity-50"
          disabled={isLoading}
        >
          Entrar
        </button>
      </form>
    </Section>
  );
};

export default Login;
